import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useLanguage } from '../contexts/LanguageContext';
import {Drone, ArrowRight, ShieldCheck} from 'lucide-react';
import { motion } from 'framer-motion';

const Login = () => {
  const { signIn, isAuthenticated } = useAuth();
  const { t } = useLanguage();
  const navigate = useNavigate();

  useEffect(() => {
    if (isAuthenticated) {
      navigate('/dashboard');
    }
  }, [isAuthenticated, navigate]);

  return (
    <div className="min-h-[80vh] flex items-center justify-center bg-slate-50 px-4">
      <div className="max-w-md w-full bg-white rounded-2xl shadow-xl overflow-hidden border border-slate-100">
        <div className="p-8 text-center">
          <div className="w-16 h-16 bg-sky-100 rounded-full flex items-center justify-center mx-auto mb-6 text-sky-600">
            <Drone className="h-8 w-8" />
          </div>
          
          <h2 className="text-2xl font-bold text-slate-900 mb-2">Welcome Back</h2>
          <p className="text-gray-500 mb-8">Sign in to access your Iron Hawk dashboard and manage service requests.</p>
          
          <div className="space-y-4">
            <button
              onClick={() => signIn()}
              className="w-full flex items-center justify-center gap-2 bg-slate-900 hover:bg-slate-800 text-white py-3 px-4 rounded-xl font-semibold transition-all transform hover:scale-[1.02]"
            >
              <span>Sign In with Iron Hawk ID</span>
              <ArrowRight className="h-4 w-4" />
            </button>
          </div>

          <div className="mt-8 pt-6 border-t border-slate-100">
            <div className="flex items-center justify-center gap-2 text-sm text-gray-400">
              <ShieldCheck className="h-4 w-4" />
              <span>Secure Authentication by Lumi</span>
            </div>
          </div>
        </div>
        
        <div className="bg-slate-50 p-4 text-center text-xs text-gray-400 border-t border-slate-100">
          By signing in, you agree to our Terms of Service and Privacy Policy.
        </div>
      </div>
    </div>
  );
};

export default Login;
